import { Route } from "react-router-dom";
import CoachingDashboard from "@/modules/hub/features/CoachingDashboard/components/CoachingDasboard/CoachingDashboard";
import MainLayout from "@/components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";

// Create stable component reference
const CoachingMainLayout = () => <MainLayout section="coaching" />;

const CoachingRoutes = (
  <Route
    element={<AuthenticationGuard component={CoachingMainLayout} />}
    path="/coaching"
  >
    <Route element={<CoachingDashboard />} index />
  </Route>
);

export default CoachingRoutes;
